import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import WYSIWYGEditorInput from '../../common/WYSIWYGEditorInput'; // Assuming the file location

const WYSIWYGEditorComponent = () => {
    return (
        <div className="page-content components">
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">WYSIWYG Editor Input Showcase</h2>

                        {/* First Row - Required Editor */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <WYSIWYGEditorInput
                                    label="Required WYSIWYG Editor"
                                    required={true}
                                    placeholder="Enter required text"
                                    maxLength={500}
                                    helpText="This field is required."
                                    showHelp={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<WYSIWYGEditorInput
    label="Required WYSIWYG Editor"
    required={true}
    placeholder="Enter required text"
    maxLength={500}
    helpText="This field is required."
    showHelp={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row - Optional Editor */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <WYSIWYGEditorInput
                                    label="Optional WYSIWYG Editor"
                                    required={false}
                                    placeholder="Enter optional text"
                                    maxLength={400}
                                    showHelp={true}
                                    helpText="This is optional, you can leave it blank."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<WYSIWYGEditorInput
    label="Optional WYSIWYG Editor"
    required={false}
    placeholder="Enter optional text"
    maxLength={400}
    showHelp={true}
    helpText="This is optional, you can leave it blank."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row - Custom Max Length */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <WYSIWYGEditorInput
                                    label="Editor with Custom Max Length"
                                    required={true}
                                    maxLength={300}
                                    placeholder="Max 300 characters"
                                    helpText="Enter text with up to 300 characters."
                                    showHelp={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<WYSIWYGEditorInput
    label="Editor with Custom Max Length"
    required={true}
    maxLength={300}
    placeholder="Max 300 characters"
    helpText="Enter text with up to 300 characters."
    showHelp={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row - Inline Layout Editor */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <WYSIWYGEditorInput
                                    label="Inline Layout WYSIWYG Editor"
                                    required={false}
                                    placeholder="Editor with inline layout"
                                    maxLength={350}
                                    layout="inline"
                                    helpText="This editor uses inline layout."
                                    showHelp={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<WYSIWYGEditorInput
    label="Inline Layout WYSIWYG Editor"
    required={false}
    placeholder="Editor with inline layout"
    maxLength={350}
    layout="inline"
    helpText="This editor uses inline layout."
    showHelp={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default WYSIWYGEditorComponent;
